const roleEnum = {
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_MANAGER: 'ROLE_MANAGER',
    ROLE_HOME: 'ROLE_HOME',
    ROLE_PHARMA: 'ROLE_PHARMA',
    ROLE_DOCTOR: 'ROLE_DOCTOR',
    ROLE_DRIVER: 'ROLE_DRIVER',
    ROLE_ACCOUNTING: 'ROLE_ACCOUNTING'
}
export  default roleEnum